import React from 'react';
import {Link} from 'react-router-dom';
import {DownloadReportModal} from "react-spaceship-web";
import {Helper} from "./Helper";
import ShipmentProductAudit from "./ShipmentProductAudit";
import {GetDayJs, history} from "./AppProvider";

import dayjs from "dayjs";
import duration from "dayjs/plugin/duration";
import customParseFormat from 'dayjs/plugin/customParseFormat';
// import utc from "dayjs/plugin/utc";

dayjs.extend(duration);
dayjs.extend(customParseFormat);
// dayjs.extend(utc);

export default class Shipment extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			mode: 'list',
			isLoading: true,
			shipments: [],
			qs: window.Global.getAllQueryStrings(),
		};
	}

	updateMethod(method, is_refresh_method) {
		let $search = this.$search;
		let $source = $search.find('select[name="source[]"]');
		let $method = $search.find('select[name="method"]');

		let data = window.Global.getAllQueryStrings();

		let source = $source.val();
		if (!source) {
			source = [];
			if (data.source) {
				source = [data.source];
			}
		}
		if (!method) {
			method = $method.val();
		}

		// if (is_refresh_method) {
		// 	if (source.indexOf('purchase_order') !== -1) {
		// 		$method.html('<option value="all">ทุกประเภท</option>\n<option value="receive">รับสินค้า</option>\n<option value="return">คืนสินค้า</option>');
		// 	}
		// 	if (source.indexOf('sale_order') !== -1) {
		// 		$method.html('<option value="all">ทุกประเภท</option>\n<option value="deliver">ส่งสินค้า</option>\n<option value="return">คืนสินค้า</option>');
		// 	}
		// 	if (source.indexOf('requisition') !== -1) {
		// 		$method.html('<option value="all">ทุกประเภท</option>\n<option value="borrow">เบิกสินค้า</option>\n<option value="return">คืนสินค้า</option>');
		// 	}
		// 	if (source.indexOf('between_branch') !== -1) {
		// 		$method.html('<option value="all">ทุกประเภท</option>\n<option value="deliver">ส่งสินค้าระหว่างสาขา</option>\n<option value="receive">รับสินค้าระหว่างสาขา</option>\n<option value="request">ขอสินค้าระหว่างสาขา</option>\n<option value="return">คืนสินค้า</option>');
		// 	}
		// 	if (source.indexOf('stock_transfer') !== -1) {
		// 		$method.empty();
		// 	}
		// 	if (source.indexOf('stock_adjustment') !== -1) {
		// 		$method.empty();
		// 	}
		// 	$method.dropdown('refresh');
		// 	$method.dropdown('set value', method);
		// }

		window.GlobalFunc.displayOrNot2($search, [
			{
				attr: 'data-source',
				value: source
			},
			{
				attr: 'data-method',
				value: method
			}
		]);

		let borrow_type = $search.find('select[name="borrow_type"]').val();
		let $e = window.$('<input type="text" name="reference_id_1">');
		$search.find('#reference_id_1').html($e).show();
		if (borrow_type === 'user') {
			$e.explorer({
				url: process.env.REACT_APP_DOMAIN + '/api/user',
				additionalData: {
					limit: 30,
					page: 1
				},
				key: 'user',
				template: {
					list: function (value) {
						return window.Mustache.render('<a class="item">{{name}}</a>', value);
					},
					selected: {
						text: 'name',
						value: 'id',
						placeholder: 'พนักงานที่เบิก'
					}
				}
			});
		} else if (borrow_type === 'team') {
			$e.explorer({
				url: process.env.REACT_APP_DOMAIN + '/api/team',
				additionalData: {
					limit: 30,
					page: 1
				},
				key: 'team',
				template: {
					list: function (value) {
						return window.Mustache.render('<a class="item">{{name}}</a>', value);
					},
					selected: {
						text: 'name',
						value: 'id',
						placeholder: 'ทีมที่เบิก'
					}
				}
			});
		} else if (borrow_type === 'stock') {
			$e.explorer({
				url: process.env.REACT_APP_DOMAIN + '/api/stock',
				additionalData: {
					limit: 30,
					page: 1,
					is_production_machine: 1
				},
				key: 'stock',
				template: {
					list: function (value) {
						return window.Mustache.render('<a class="item">{{name}}</a>', value);
					},
					selected: {
						text: 'name',
						value: 'id',
						placeholder: 'เครื่องผลิตสินค้า'
					}
				}
			});
		} else if (borrow_type === 'project') {
			$e.explorer({
				url: process.env.REACT_APP_DOMAIN + '/api/project',
				additionalData: {
					limit: 30,
					page: 1
				},
				key: 'project',
				template: {
					list: function (value) {
						return window.Mustache.render('<a class="item">{{name}}</a>', value);
					},
					selected: {
						text: 'name',
						value: 'id',
						placeholder: 'โครงการ'
					}
				}
			});
		} else if (borrow_type === 'relationship') {
			$e.explorer({
				url: process.env.REACT_APP_DOMAIN + '/api/relationship',
				additionalData: {
					limit: 30,
					page: 1
				},
				key: 'relationship',
				template: {
					list: function (value) {
						return window.Mustache.render('<a class="item">{{name}}</a>', value);
					},
					selected: {
						text: 'name',
						value: 'id',
						placeholder: 'คู่ค้า'
					}
				}
			});
		} else if (borrow_type === 'payment') {
			$e.explorer({
				url: process.env.REACT_APP_DOMAIN + '/api/payment',
				additionalData: {
					limit: 30,
					page: 1
				},
				key: 'payment',
				template: {
					list: function (value) {
						return window.Mustache.render('<a class="item">{{desc}}</a>', value);
					},
					selected: {
						text: 'name',
						value: 'id',
						placeholder: 'เอกสารทางการเงิน'
					}
				}
			});
		} else if (borrow_type === 'sale_order_contact') {
			$e.explorer({
				url: process.env.REACT_APP_DOMAIN + '/api/sale_order_contact',
				additionalData: {
					limit: 30,
					page: 1
				},
				key: 'sale_order_contact',
				template: {
					list: function (value) {
						return window.Mustache.render('<a class="item">{{name}}</a>', value);
					},
					selected: {
						text: 'name',
						value: 'id',
						placeholder: 'สัญญา'
					}
				}
			});
		} else {
			$search.find('#reference_id_1').html('-');
		}
	}

	fetch() {
		// let $search = this.$parent.find('#Search_root');
		let data = window.Global.getAllQueryStrings();

		if (!data['order_by']) {
			data['order_by'] = 'done_date_desc';
		}

		if (this.state.isOnlyStockTransfer) {
			data.source = ['stock_transfer'];
		}
		if (this.state.isOnlyStockAdjustment) {
			data.source = ['stock_adjustment'];
		}
		if (this.state.isOnlyRequisition) {
			data.source = ['requisition'];
		}

		data['disable_company_info'] = true;

		if (data.start_done_date
			&& data.end_done_date
			// && data.is_advance_report === "1"
		) {
			let start = GetDayJs(data.start_done_date);
			let end = GetDayJs(data.end_done_date);
			let diffTime = end.unix() - start.unix();
			let duration = dayjs.duration(diffTime * 1000, "milliseconds");
			if (duration.months() <= 2) {
				data['request_data_summary'] = true;
				data.all = true;
			}
		}

		let isHideStockStats = true;

		if (!data.status) {
			data.status = 'all';
		}

		if (!data.search_query
			&& !data.start_doc_date
			&& !data.end_doc_date
			&& !data.stock_id
			&& !data.shipment_tracking_remark
			&& !data.source
			&& !data.relationship_id
			&& !data.product_template_id
			&& !data.filter_shipment_id
			// && !data.has_product_ids
			&& (
				!data.status
				|| data.status === 'done,complete'
				|| data.status === 'all'
			)
			&& !data.created_user_id
			&& !data.approved_user_id
			&& !data.responsibility_user_id
			&& (
				!data.is_has_shipment_file_upload
				|| data.is_has_shipment_file_upload === 'all'
			)
		) {
			isHideStockStats = false;
		}

		if (data.is_request_excel_is_display_shipment_item_by_product_filter) {
			// let data2 = window.Global.getAllQueryStrings();
			delete data.is_request_excel_is_display_shipment_item_by_product_filter
			history.replace(
				window.Global.getQueryStringLinkFromObject(data)
			)
			this.downloadReport('excel_is_display_shipment_item_by_product_filter', data)
			return;
		}

		window.Global.ajax({
			method: 'GET',
			url: process.env.REACT_APP_DOMAIN + '/api/shipment',
			data: data,
			done: (response) => {
				this.setState({
					isLoading: false,
					shipments: response.shipment,
					summary: response.summary,
					qs: window.Global.getAllQueryStrings(),
					has_product: response.has_product || [],
					company_info: response.company_info || false,
					isHideStockStats: isHideStockStats,
				}, () => {
					if (this.state.isOnlyStockTransfer) {
						this.$parent.find('.menu-style-1 .item').hide();
						this.$parent.find('.menu-style-1 .item[data-value="stock_transfer"]').show().trigger('click');

						// this.$parent.find('select[name="source[]"]').closest('.column').hide();

						// this.$parent.find('input[name="relationship_id"]').closest('.column').remove();
						// this.$parent.find('select[name="status[]"]').closest('.column').remove();
						// this.$parent.find('input[name="shipment_tracking_remark"]').closest('.column').remove();

						// let $stock_id = this.$parent.find('input[name="stock_id"]').closest('.column').detach();
						// $stock_id.find('label').text('โอนออกจากคลังสินค้า');
						// this.$parent.find('input[name="stock_transfer_stock_2_id"]').closest('.column').before($stock_id);
					}
					if (this.state.isOnlyStockAdjustment) {
						this.$parent.find('.menu-style-1 .item').hide();
						this.$parent.find('.menu-style-1 .item[data-value="stock_adjustment"]').show().trigger('click');

						// this.$parent.find('select[name="source[]"]').closest('.column').hide();

						// this.$parent.find('input[name="relationship_id"]').closest('.column').remove();
						// this.$parent.find('select[name="status[]"]').closest('.column').remove();
						// this.$parent.find('input[name="start_doc_date"]').closest('.column').remove();
						// this.$parent.find('input[name="end_doc_date"]').closest('.column').remove();
						// this.$parent.find('input[name="shipment_tracking_remark"]').closest('.column').remove();

						// let $stock_id = this.$parent.find('input[name="stock_id"]').closest('.column').detach();
						// $stock_id.find('label').text('คลังสินค้า');
						// this.$parent.find('input[name="stock_transfer_stock_2_id"]').closest('.column').before($stock_id);
					}
					if (this.state.isOnlyRequisition) {
						this.$parent.find('.menu-style-1 .item').hide();
						this.$parent.find('.menu-style-1 .item[data-value="requisition"]').show().trigger('click');

						// this.$parent.find('select[name="source[]"]').closest('.column').hide();

						// this.$parent.find('input[name="relationship_id"]').closest('.column').remove();
						// this.$parent.find('select[name="status[]"]').closest('.column').remove();

						// if (this.state.qs.requisition_method === 'return') {
						// 	this.$parent.find('select[name="borrow_type"]').closest('.column').remove();
						// 	this.$parent.find('#reference_id_1').closest('.column').remove();
						// }

						// let $stock_id = this.$parent.find('input[name="stock_id"]').closest('.column').detach();
						// $stock_id.find('label').text('คลังสินค้า');
						// this.$parent.find('input[name="stock_transfer_stock_2_id"]').closest('.column').before($stock_id);
					}

					this.updateMethod(data['method']);

					this.$search.find('form').form2('init', {
						data: data,
						disableSetTemplate: true,
						disableTriggerOnChange: true,
						disableTriggerOnKeyup: true,
						useForm: true,
						withoutDataReset: true,
					});

					this.$search.find('.Explorer').each(function () {
						window.$(this).explorer('clear');
					});

					this.$parent.find('.Table_root').tablePagination({
						disableContent: true,
						data: response.shipment,
						count: response.count,
						maxSize: data.limit ? parseInt(data.limit) : 10,
						onClickPagination: (p) => {
							let qs = window.Global.getAllQueryStrings();
							qs.page = p;
							this.props.history.push(window.Global.getQueryStringLinkFromObject(qs));
						}
					});

					if (response['relationship']) {
						this.$relationship.explorer('set value', response['relationship']);
					}
					if (response['related_branch']) {
						this.$search.find('input[name="related_branch_id"]').explorer('set value', response['related_branch']);
					}
					setTimeout(() => {
						if (response['reference_id_1']) {
							this.$search.find('.Explorer[data-explorer_input_name="reference_id_1"]').explorer('set value', response['reference_id_1']);
						}
					})

					if (response['product_template']) {
						window.$.each(response['product_template'], (i, product_template) => {
							this.$product_template.explorer('set value', product_template);
						});
					}

					if (response['filter_shipment']) {
						window.$.each(response['filter_shipment'], (i, filter_shipment) => {
							this.$search.find('.Explorer[data-explorer_input_name="filter_shipment_id[]"]').explorer('set value', filter_shipment);
						});
					}

					if (response['responsibility_user']) {
						window.$.each(response['responsibility_user'], (i, responsibility_user) => {
							this.$search.find('.Explorer[data-explorer_input_name="responsibility_user_id[]"]').explorer('set value', responsibility_user);
						});
					}

					if (response['has_product']) {
						window.$.each(response['has_product'], (i, has_product) => {
							this.$search.find('.Explorer[data-explorer_input_name="has_product_ids[]"]').explorer('set value', has_product);
						});
					}

					if (response['search_product_serial_number']) {
						window.$.each(response['search_product_serial_number'], (i, product_serial_number) => {
							this.$search.find('.Explorer[data-explorer_input_name="search_product_serial_number[]"]').explorer('set value', product_serial_number);
						});
					}

					if (response['stock']) {
						this.$search.find('input[name="stock_id"]').explorer('set value', response['stock']);
					}

					if (response['stock_transfer_stock_2']) {
						this.$search.find('input[name="stock_transfer_stock_2_id"]').explorer('set value', response['stock_transfer_stock_2']);
					}

					if (response['created_user']) {
						this.$search.find('input[name="created_user_id"]').explorer('set value', response['created_user']);
					}

					if (response.source) {
						this.$search.find('select[name="source[]"]').dropdown('set selected', response.source);
					}

					if (response.stock_transfer_status) {
						this.$search.find('select[name="stock_transfer_status[]"]').dropdown('set selected', response.stock_transfer_status);
					}

					if (response.stock_adjustment_status) {
						this.$search.find('select[name="stock_adjustment_status[]"]').dropdown('set selected', response.stock_adjustment_status);
					}

					if (response.requisition_status) {
						this.$search.find('select[name="requisition_status[]"]').dropdown('set selected', response.requisition_status);
					}

					if (response.status) {
						let status2 = [];
						window.$.each(response.status, function (i, status) {
							if (status === 'done' || status === 'complete') {
								status2.push('done,complete');
							} else {
								status2.push(status);
							}
						});
						if (status2.length) {
							this.$search.find('select[name="status[]"]').dropdown('set selected', status2);
						}
					}

					let $body = window.$('body');
					if ($body.width() < 500) {
						$body.addClass("nohover");
						window.$("#shipment-list td, #shipment-list th")
							.attr("tabindex", "1")
							.on("touchstart", function () {
								window.$(this).focus();
							});
					}

					// if (this.state.qs.is_request_excel_is_display_shipment_item_by_product_filter) {
					// 	let qs = window.Global.getAllQueryStrings();
					// 	delete qs.is_request_excel_is_display_shipment_item_by_product_filter
					// 	history.replace(
					// 		window.Global.getQueryStringLinkFromObject(qs)
					// 	)
					//
					// 	this.downloadReport('excel_is_display_shipment_item_by_product_filter')
					// }
				})
			}
		});
	}

	processShowManageButton($e, shipment) {
		if (shipment['method'] === 'borrow'
			&& shipment['is_done'] === 1
			&& shipment['is_deleted'] === 0
		) {
			$e.find('#return-button').show();
		}

		if (!window.user) {
			return;
		}

		if (shipment['method'] === 'request'
			&& shipment['branch_id'] !== window.user['current_branch']['id']
			&& shipment['related_branch_id'] === window.user['current_branch']['id']
			&& shipment['is_deleted'] === 0
		) {
			$e.find('#create-deliver-button').show();
		}

		if (shipment['method'] === 'deliver'
			&& shipment['related_branch_id'] === window.user['current_branch']['id']
			&& shipment['is_deleted'] === 0
		) {
			$e.find('#receive-button').show();
		}

		if (shipment['method'] === 'deliver'
			&& shipment['source'] === 'between_branch'
			&& ['receive_some_and_remain_return', 'receive_some_and_return_some_and_remain_some', 'return_some_and_remain_some', 'none']
				.indexOf(shipment['shipment_item_quantity_action_status']) !== -1
			&& shipment['is_done'] === 1
			&& shipment['branch_id'] === window.user['current_branch']['id']
			&& shipment['is_deleted'] === 0
		) {
			$e.find('#return-button').show();
		}
	}

	componentDidMount() {
		this.route();
	}

	route() {
		window.Route.on({
			'/v2/requisition': () => {
				this.setState({
					mode: 'list',
					isLoading: true,
					shipments: [],
					isOnlyRequisition: true,
					isOnlyStockAdjustment: false,
					isOnlyStockTransfer: false,
				}, () => {
					this.fetch();
				})
			},
			'/v2/stock_adjustment': () => {
				this.setState({
					mode: 'list',
					isLoading: true,
					shipments: [],
					isOnlyStockAdjustment: true,
					isOnlyStockTransfer: false,
					isOnlyRequisition: false,
				}, () => {
					this.fetch();
				})
			},
			'/v2/stock_transfers': () => {
				this.setState({
					mode: 'list',
					isLoading: true,
					shipments: [],
					isOnlyStockTransfer: true,
					isOnlyStockAdjustment: false,
					isOnlyRequisition: false,
				}, () => {
					this.fetch();
				})
			},
			'/v2/shipments': () => {
				this.setState({
					mode: 'list',
					isLoading: true,
					shipments: [],
					isOnlyStockTransfer: false,
					isOnlyStockAdjustment: false,
					isOnlyRequisition: false,
				}, () => {
					this.fetch();
				})
			},
		}).match();
	}

	componentDidUpdate(prevProps, prevState) {
		if (this.props.location.pathname !== prevProps.location.pathname) {
			this.route();
		} else if (this.props.location.search !== prevProps.location.search) {
			this.route();
		}
	}

	downloadReport(value, data) {
		if (!data) {
			data = this.$search.find('form').serializeObject();
			if (!data['order_by']) {
				data['order_by'] = 'newest';
			}
		}

		// if (!data['start_doc_date']
		// 	|| !data['end_doc_date']
		// ) {
		// 	if (!data['start_done_date']
		// 		|| !data['end_done_date']
		// 	) {
		// 		Global.messageTop({
		// 			type: 'negative',
		// 			message: 'ระบุช่วงวันที่เอกสาร หรือวันที่ส่งสินค้า'
		// 		});
		// 		return;
		// 	}
		// }
		if (value === 'excel') {
			data.is_download_excel = true;
			window.Global.reactToDom(
				window.$('body'),
				<DownloadReportModal
					url={process.env.REACT_APP_DOMAIN + '/api/shipment'}
					data={data}
				/>
			);
		}
		if (value === 'excel_is_display_shipment_item_by_product_filter') {
			data.is_download_excel = true;
			data.is_display_shipment_item_by_product_filter = true;
			window.Global.reactToDom(
				window.$('body'),
				<DownloadReportModal
					url={process.env.REACT_APP_DOMAIN + '/api/shipment'}
					data={data}
				/>
			);
		}
	}

	renderList() {
		let summary = false;
		let keys = [];
		if (this.state.summary
			&& this.state.summary.product_id
		) {
			summary = this.state.summary;
			for (let d in summary.product_id) {
				for (let k in summary.product_id[d]) {
					if (k === 'prev'
						|| k === 'current'
					) {
						continue;
					}
					if (k !== 'product'
						&& keys.indexOf(k) === -1
					) {
						keys.push(k);
					}
				}
			}
		}

		let buttons = [
			{
				start_done_date: window.moment().format('YYYY-MM-DD'),
				end_done_date: window.moment().format('YYYY-MM-DD'),
				title: 'วันนี้',
			},
			{
				start_done_date: window.moment().subtract(1, 'days').format('YYYY-MM-DD'),
				end_done_date: window.moment().subtract(1, 'days').format('YYYY-MM-DD'),
				title: 'เมื่อวาน',
			},
			{
				start_done_date: window.moment().startOf('week').format('YYYY-MM-DD'),
				end_done_date: window.moment().endOf('week').format('YYYY-MM-DD'),
				title: 'สัปดาห์นี้',
			},
			{
				start_done_date: window.moment().startOf('month').format('YYYY-MM-DD'),
				end_done_date: window.moment().endOf('month').format('YYYY-MM-DD'),
				title: 'เดือนนี้',
			},
			{
				start_done_date: this.state.qs.start_done_date,
				end_done_date: this.state.qs.end_done_date,
				title: this.state.qs.start_done_date
				&& this.state.qs.end_done_date
					? (
						window.Global.getDateThai(this.state.qs.start_done_date)
						+ ' - '
						+ window.Global.getDateThai(this.state.qs.end_done_date)
					)
					: null,
			},
		];

		let isAlready = false;

		for (let x in buttons) {
			buttons[x].style = {
				background: '#ffffff14',
				color: '#FFF',
				border: '1px solid #ffffff40',
			}
			if (this.state.qs.start_done_date === buttons[x].start_done_date
				&& this.state.qs.end_done_date === buttons[x].end_done_date
			) {
				buttons[x].style = {};

				if (x !== '4') {
					isAlready = true;
				}
			}

			if (x === '4') {
				if (isAlready
					|| (
						!this.state.qs.start_done_date
						|| !this.state.qs.end_done_date
					)
				) {
					buttons[x].hide = true;
				} else {
					isAlready = true;
				}
			}
		}

		// if (this.state.qs.is_advance_report !== "1") {
		// 	isAlready = false;
		// }

		return (
			<div className="main ui container"
			     key={'x' + window.Global.getRandomInt(1, 10000000)}
			     ref={(ref) => {
				     this.$parent = window.$(ref);
				     this.$search = this.$parent.find('#Search_root');

				     let data = window.Global.getAllQueryStrings();

				     this.updateMethod(data['method'], true);

				     window.Search.init({
					     $node: this.$search,
					     form2_setup_on_change: {
						     borrow_type_onChange: () => {
							     this.updateMethod('', true);
						     },
						     'source[]_onChange': () => {
							     this.updateMethod('', true);
						     },
						     method_onChange: (method) => {
							     this.updateMethod(method, false);
						     }
					     },
					     onSubmit: (data) => {
						     this.props.history.push(window.Global.getQueryStringLinkFromObject(data));
						     return false;
					     }
				     });

				     this.$search.find('input[name="related_branch_id"]').explorer({
					     url: process.env.REACT_APP_DOMAIN + '/api/branch',
					     key: 'branch',
					     template: {
						     list: function (value) {
							     return window.Mustache.render('<a class="item">{{name}}</a>', value);
						     },
						     selected: {
							     text: 'name',
							     value: 'id',
							     placeholder: 'เกี่ยวกับสาขาอื่น'
						     }
					     }
				     });
				     this.$relationship = this.$search.find('input[name="relationship_id"]').explorer({
					     url: process.env.REACT_APP_DOMAIN + '/api/relationship',
					     key: 'relationship',
					     template: {
						     list: function (value) {
							     return window.Mustache.render('<a class="item">{{name}}</a>', value);
						     },
						     selected: {
							     text: 'name',
							     value: 'id',
							     placeholder: 'ไม่ระบุ'
						     }
					     }
				     });
				     this.$product_template = this.$search.find('input[name="product_template_id[]"]').explorer({
					     url: process.env.REACT_APP_DOMAIN + '/api/product_template',
					     multiple: true,
					     additionalData: () => {
						     return {
							     limit: 30,
							     exclude_id: this.$product_template.explorer('get value')
						     }
					     },
					     key: 'product_template',
					     template: {
						     list: function (value) {
							     return window.Mustache.render('<div class="item">{{name}}</div>', value);
						     },
						     selected: {
							     display_template: '<div>{{name}}</div>',
							     value: 'id',
							     placeholder: 'กิจกรรมประจำ'
						     }
					     }
				     });
				     this.$search.find('input[name="filter_shipment_id[]"]').explorer({
					     url: process.env.REACT_APP_DOMAIN + '/api/filter',
					     multiple: true,
					     additionalData: () => {
						     let type = 'shipment';
						     if (this.state.isOnlyStockTransfer) {
							     type = 'stock_transfer';
						     } else if (this.state.isOnlyStockAdjustment) {
							     type = 'stock_adjustment';
						     }
						     return {
							     type: type,
							     limit: 30,
							     exclude_filter_id: this.$search.find('div[data-explorer_input_name="filter_shipment_id[]"]').explorer('get value')
						     }
					     },
					     key: 'filter',
					     template: {
						     list: function (value) {
							     return window.Mustache.render('<div class="item">{{name}}</div>', value);
						     },
						     selected: {
							     display_template: '<div>{{name}}</div>',
							     value: 'id',
							     placeholder: 'Tags'
						     }
					     }
				     });
				     let $has_product_ids = this.$search.find('input[name="has_product_ids[]"]').explorer({
					     url: process.env.REACT_APP_DOMAIN + '/api/product',
					     multiple: true,
					     additionalData: function () {
						     return {
							     page: 1,
							     limit: 30,
							     exclude_product_id: $has_product_ids.explorer('get value')
						     }
					     },
					     key: 'product',
					     template: {
						     list: '<a class="item flex row">\n\t<span style="color: green;">{{name}}</span><br><span style="color: #4c4c4c;">{{code}}</span>\n</a>',
						     selected: {
							     display_template: '<span>{{name}} <a href="/v2/products/{{id}}" target="_blank"><i class="icon linkify"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tstyle="font-size: 0.8rem;margin: 0;color: #646464;"></i></a></span>',
							     value: 'id',
							     placeholder: 'ค้นหาสินค้าที่เกี่ยวข้อง'
						     }
					     }
				     });
				     let $search_product_serial_number = this.$search.find('input[name="search_product_serial_number[]"]').explorer({
					     url: process.env.REACT_APP_DOMAIN + '/api/product_serial_number',
					     multiple: true,
					     additionalData: function () {
						     return {
							     page: 1,
							     limit: 30,
							     serial_number_is_set: 1,
							     allow_deleted: 1,
							     exclude_product_serial_number_id: $search_product_serial_number.explorer('get value')
						     }
					     },
					     key: 'product_serial_number',
					     template: {
						     list: '<a class="item flex row">\n\t{{#serial_number}}\n\t<span style="color: green;">{{serial_number}}</span>\n\t{{/serial_number}}\n\t{{^serial_number}}\n\t<span style="color: green;">ไม่ได้ตั้ง serial number</span>\n\t{{/serial_number}}\n\t{{#expire_date}}\n\t<br>\n\t<span style="color: #4c4c4c;">หมดอายุ {{expire_date}}</span>\n\t{{/expire_date}}\n</a>',
						     selected: {
							     display_template: '<span>{{serial_number}} <a href="/v2/products/{{product_id}}/serial-number?search_serial_number={{serial_number}}" target="_blank"><i class="icon linkify"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tstyle="font-size: 0.8rem;margin: 0;color: #646464;"></i></a></span>',
							     value: 'id',
							     placeholder: 'ไม่ระบุ'
						     }
					     }
				     });
				     this.$search.find('input[name="stock_id"]').explorer({
					     url: process.env.REACT_APP_DOMAIN + '/api/stock',
					     additionalData: {
						     limit: 30,
						     page: 1
					     },
					     key: 'stock',
					     template: {
						     list: '<a class="item flex row">{{name}}</a>',
						     selected: {
							     text: 'name',
							     value: 'id',
							     placeholder: 'คลังสินค้า'
						     }
					     }
				     });
				     this.$search.find('input[name="stock_transfer_stock_2_id"]').explorer({
					     url: process.env.REACT_APP_DOMAIN + '/api/stock',
					     additionalData: {
						     limit: 30,
						     page: 1
					     },
					     key: 'stock',
					     template: {
						     list: '<a class="item flex row">{{name}}</a>',
						     selected: {
							     text: 'name',
							     value: 'id',
							     placeholder: 'โอนเข้าคลังสินค้า'
						     }
					     }
				     });
				     this.$search.find('input[name="created_user_id"]').explorer({
					     url: process.env.REACT_APP_DOMAIN + '/api/user',
					     additionalData: {
						     limit: 30,
						     page: 1
					     },
					     key: 'user',
					     template: {
						     list: '<a class="item flex row">{{name}}</a>',
						     selected: {
							     text: 'name',
							     value: 'id',
							     placeholder: 'ผู้บันทึกข้อมูล'
						     }
					     }
				     });
				     this.$search.find('input[name="approved_user_id"]').explorer({
					     url: process.env.REACT_APP_DOMAIN + '/api/user',
					     additionalData: {
						     limit: 30,
						     page: 1
					     },
					     key: 'user',
					     template: {
						     list: '<a class="item flex row">{{name}}</a>',
						     selected: {
							     text: 'name',
							     value: 'id',
							     placeholder: 'ผู้อนุมัติ'
						     }
					     }
				     });
				     this.$search.find('input[name="responsibility_user_id[]"]').explorer({
					     url: process.env.REACT_APP_DOMAIN + '/api/user',
					     multiple: true,
					     additionalData: {
						     limit: 30,
						     page: 1
					     },
					     key: 'user',
					     template: {
						     list: '<a class="item flex row">{{name}}</a>',
						     selected: {
							     text: 'name',
							     value: 'id',
							     placeholder: 'พนักงานที่รับผิดชอบ'
						     }
					     }
				     });

				     // let text = 'ความเคลื่อนไหวสินค้า';
				     // let url = '/v2/shipments';
				     // if ((
				     //      data['source'] === 'requisition'
				     //      || data['source'] === 'between_branch'
				     //      || data['source'] === 'stock_transfer'
				     //      || data['source'] === 'stock_adjustment'
				     //    )
				     //    && data['method']
				     // ) {
				     // let $addShipmentButton = window.$('#addShipmentButton');
				     // if (data['source'] === 'requisition') {
				     //    if (data['method'] === 'borrow') {
				     //      text = 'เบิกใช้สินค้า'
				     //    } else {
				     //      text = 'คืนสินค้า'
				     //    }
				     //    $addShipmentButton.attr('href', '/v2/shipments/new?source=' + data['source'] + '&method=' + data['method'])
				     //      .text('สร้างใบ' + text)
				     //      .show();
				     // }
				     // if (data['source'] === 'between_branch') {
				     //    if (data['method'] === 'deliver') {
				     //      text = 'ส่งสินค้าระหว่างสาขา'
				     //    } else if (data['method'] === 'receive') {
				     //      text = 'รับสินค้าระหว่างสาขา'
				     //    } else if (data['method'] === 'request') {
				     //      text = 'ขอสินค้าระหว่างสาขา'
				     //    } else if (data['method'] === 'return') {
				     //      text = 'คืนสินค้า'
				     //    }
				     //    $addShipmentButton.attr('href', '/v2/shipments/new?source=' + data['source'] + '&method=' + data['method'])
				     //      .text('สร้างใบ' + text)
				     //      .show();
				     // }
				     // if (data['source'] === 'stock_transfer') {
				     // text = 'โอนย้ายระหว่างคลัง';
				     // }
				     // if (data['source'] === 'stock_adjustment') {
				     // text = 'ปรับสินค้าคงคลัง';
				     // }
				     // url = '/v2/shipments?source=' + data['source'] + '&method=' + data['method'];
				     // }

				     // window.$('#HeaderTop_root').find('.breadcrumb').html(window.Mustache.render('<a class="section active" href="{{url}}">{{title}}</a>', {
				     //    title: text,
				     //    url: url
				     // }));

				     this.$search.find('.pointing.dropdown').dropdown({
					     onChange: (value) => {
						     this.downloadReport(value, false)
					     }
				     });

				     let $search = this.$search;
				     $search.find('.menu-style-1 > .item').each(function () {
					     window.$(this).on('click', function () {
						     let source = window.$(this).data('value');

						     $search.find('.menu-style-1 .item').hide();
						     $search.find('.menu-style-1 .item[data-value="' + source + '"]').show();

						     $search.find('.menu-style-1 > .item').removeClass('active');
						     window.$(this).addClass('active');

						     $search.find('div[data-filter-source]').hide();
						     $search.find('div[data-filter-source="' + source + '"]').show();
					     });
				     });
			     }}>
				<div id="HeaderTop_root" className="flex top-xs" style={{marginBottom: '1rem'}}>
					<div className="flex row wrap" style={{flex: 1, width: '100%'}}>
						<div className="flex row middle-xs">
							<div className="ui huge breadcrumb flex row">
								<Link className="active section" to="/v2/shipments">ความเคลื่อนไหวสินค้า</Link>
								{
									this.state.isOnlyStockTransfer
									&&
									<>
										<span className="divider" style={{margin: '0 1rem'}}>/</span>
										<Link className="active section"
										      to="/v2/stock_transfers">
											<span>โอนย้ายสินค้าระหว่างคลัง</span>
										</Link>
									</>
								}
								{
									this.state.isOnlyStockAdjustment
									&&
									<>
										<span className="divider" style={{margin: '0 1rem'}}>/</span>
										<Link className="active section"
										      to="/v2/stock_adjustment">
											<span>ปรับสินค้าคงคลัง</span>
										</Link>
									</>
								}
								{
									this.state.isOnlyRequisition
									&&
									<>
										<span className="divider" style={{margin: '0 1rem'}}>/</span>
										<Link className="active section"
										      to={"/v2/requisition?source=requisition&requisition_method=" + this.state.qs.requisition_method}>
											{
												this.state.qs.requisition_method === 'borrow'
												&&
												"เบิกสินค้า"
											}
											{
												this.state.qs.requisition_method === 'return'
												&&
												"คืนสินค้าจากการเบิกใช้"
											}
										</Link>
									</>
								}
							</div>
							<span id="count-shipment"/>
						</div>
						<div className="ui message info small"
						     style={{
							     margin: '0 0 0 1rem',
							     padding: '0.7rem',
							     fontSize: '0.9rem',
						     }}>
							<span
								className="ui label green tiny">อัพเดท</span>&nbsp;&nbsp;สามารถตรวจสอบประวัติสินค้าประเภทซีเรียล
						</div>
						<div className="right floated">
							{/*<Link id="addShipmentButton"*/}
							{/*      to="/shipments/new"*/}
							{/*      className="ui positive button"*/}
							{/*      style={{display: 'none'}}*/}
							{/*/>*/}
							{
								this.state.isOnlyStockTransfer
								&&
								<Link to="/v2/stock_transfers/new"
								      className="ui positive button">
									สร้างโอนย้ายสินค้าระหว่างคลัง
								</Link>
							}
							{
								this.state.isOnlyStockAdjustment
								&&
								<Link to="/v2/stock_adjustment/new"
								      className="ui positive button">
									สร้างปรับสินค้าคงคลัง
								</Link>
							}
							{
								this.state.isOnlyRequisition
								&&
								<a href={"/shipments/new?source=requisition&method=" + this.state.qs.requisition_method}
								   className="ui positive button">
									{
										this.state.qs.requisition_method === 'borrow'
										&&
										"เบิกสินค้า"
									}
									{
										this.state.qs.requisition_method === 'return'
										&&
										"คืนสินค้า"
									}
								</a>
							}
						</div>
					</div>
					<div id="Search_root"
					     className="box"
					     style={{marginTop: '1rem'}}>
						<form className="ui form">
							<div className="flex row padded wrap five column computer" style={{padding: 0}}>
								<div className="column field">
									<label htmlFor="">ค้นหาเลขที่เอกสาร</label>
									<input type="text" name="search_query" placeholder="ค้นหาเลขที่เอกสาร" autoComplete="off"/>
								</div>
								<div className="column field">
									<label htmlFor="">สินค้า</label>
									<input type="text"
									       name="has_product_ids[]"
									/>
								</div>
								{
									(!this.state.isOnlyStockTransfer
										&& !this.state.isOnlyStockAdjustment
										&& !this.state.isOnlyRequisition
									)
									&&
									<div className="column field">
										<label htmlFor="">คู่ค้า</label>
										<input type="text"
										       name="relationship_id"
										/>
									</div>
								}
								<div className="column field">
									<div className="field">
										<label htmlFor="">ระหว่างวันที่ดำเนินการ <span
											className="ui label green tiny">ยอดคลังวิ่งตามวันที่นี้</span></label>
										<div data-form_calendar="date"
										     data-input_name="start_done_date"
										     data-placeholder="ไม่ระบุ"
										     data-end_calendar="end_done_date"
										     data-locale="th"
										     data-initialdate=""
										/>
									</div>
								</div>
								<div className="column field">
									<div className="field">
										<label htmlFor="">ถึงวันที่ดำเนินการ</label>
										<div data-form_calendar="date"
										     data-input_name="end_done_date"
										     data-placeholder="ไม่ระบุ"
										     data-start_calendar="start_done_date"
										     data-locale="th"
										     data-initialdate=""
										/>
									</div>
								</div>
								{
									(!this.state.isOnlyStockTransfer
										&& !this.state.isOnlyStockAdjustment
										&& !this.state.isOnlyRequisition
									)
									&&
									<div className="column field">
										<label htmlFor="">สถานะ <span
											data-tooltip="กิจกรรมต่างๆจะกรองตามสถานะนี้ หากต้องการแยกสถานะตามเหตุการณ์สามารถกรองได้ที่ Tab แต่ละเหตุการณ์"
											data-position="top left"
											data-inverted=""><i className="icon info circle"/></span>
										</label>
										<select className="ui dropdown fluid"
										        name="status[]"
										        multiple="multiple"
										        data-onchange=""
										        data-form2_setup="true">
											<option value="">ทุกสถานะ</option>
											<option value="done,complete">สมบูรณ์ / เสร็จสิ้น</option>
											<option value="draft">ฉบับร่าง</option>
											<option value="void">ยกเลิก</option>
											<option value="wait_processing">รอดำเนินการ</option>
											<option value="processing">อยู่ระหว่างดำเนินการ / กำลังผลิต</option>
										</select>
									</div>
								}
								<div className="column field"
								     style={
									     (this.state.isOnlyStockTransfer
										     || this.state.isOnlyStockAdjustment
										     || this.state.isOnlyRequisition
									     )
										     ? {display: 'none'}
										     : {}
								     }
								>
									<label htmlFor="">เหตุการณ์</label>
									<select className="ui dropdown fluid"
									        name="source[]"
									        multiple="multiple"
									        data-onchange=""
									        data-form2_setup="true">
										<option value="">ทุกเหตุการณ์</option>
										<option value="product_initial">ยอดยกมา</option>
										<option value="purchase_order">ซื้อ</option>
										<option value="sale_order">ขาย</option>
										<option value="stock_transfer">โอนย้ายสินค้าระหว่างคลัง</option>
										<option value="stock_adjustment">ปรับสินค้าคงคลัง</option>
										<option value="requisition">เบิกใช้สินค้า</option>
										<option value="bom_adjustment">ผลิตสินค้า</option>
										<option value="between_branch">ระหว่างสาขา</option>
									</select>
								</div>
								<div className="column field">
									<div className="field">
										<label htmlFor="">เรียงข้อมูล</label>
										<select className="ui dropdown fluid" name="order_by" data-form2_setup="true">
											<option value="done_date_desc">วันที่ดำเนินการ : ใหม่สุด ไป เก่าสุด</option>
											<option value="done_date">วันที่ดำเนินการ : เก่าสุด ไป ใหม่สุด</option>
											<option value="newest">วันที่เอกสาร : ใหม่สุด ไป เก่าสุด</option>
											<option value="oldest">วันที่เอกสาร : เก่าสุด ไป ใหม่สุด</option>
										</select>
									</div>
								</div>
								{
									!this.state.isOnlyStockAdjustment
									&&
									<>
										<div className="column field">
											<div className="field">
												<label htmlFor="">ระหว่าง<u>วันที่เอกสาร</u></label>
												<div data-form_calendar="date"
												     data-input_name="start_doc_date"
												     data-placeholder="ไม่ระบุ"
												     data-end_calendar="end_doc_date"
												     data-locale="th"
												     data-initialdate=""
												/>
											</div>
										</div>
										<div className="column field">
											<div className="field">
												<label htmlFor="">ถึง<u>วันที่เอกสาร</u></label>
												<div data-form_calendar="date"
												     data-input_name="end_doc_date"
												     data-placeholder="ไม่ระบุ"
												     data-start_calendar="start_doc_date"
												     data-locale="th"
												     data-initialdate=""
												/>
											</div>
										</div>
									</>
								}
								<div className="column field">
									<label htmlFor="">กิจกรรมประจำ</label>
									<input type="text"
									       name="product_template_id[]"
									/>
								</div>
								<div className="column field">
									<label htmlFor="">Tags</label>
									<input type="text"
									       name="filter_shipment_id[]"
									/>
								</div>
								<div className="column field">
									<div className="field">
										<label htmlFor="">ไฟล์อัพโหลด</label>
										<select className="ui dropdown fluid"
										        name="is_has_shipment_file_upload"
										        data-form2_setup="true">
											<option value="all">ทั้งหมด</option>
											<option value="1">มี</option>
											<option value="0">ไม่มี</option>
										</select>
									</div>
								</div>
								<div className="column field">
									<label htmlFor="">จำนวนต่อหน้า</label>
									<select className="ui dropdown fluid"
									        name="limit"
									        data-form2_setup="true">
										<option value="10">10</option>
										<option value="20">20</option>
										<option value="50">50</option>
									</select>
								</div>
								{
									(!this.state.isOnlyStockTransfer
										&& !this.state.isOnlyStockAdjustment
										&& !this.state.isOnlyRequisition
									)
									&&
									<div className="column field">
										<label htmlFor="">คลังสินค้า</label>
										<input type="text"
										       name="stock_id"
										       autoComplete="off"
										/>
									</div>
								}
								{
									(
										!this.state.isOnlyStockTransfer
										&& !this.state.isOnlyStockTransfer
									)
									&&
									<div className="column field">
										<label htmlFor="">ค้นหารหัสติดตามพัสดุ</label>
										<input type="text"
										       name="shipment_tracking_remark"
										       placeholder="ค้นหารหัสติดตามพัสดุ"
										       autoComplete="off"
										/>
									</div>
								}
								<div className="column field">
									<label htmlFor="">ผู้บันทึก</label>
									<input type="text"
									       name="created_user_id"
									/>
								</div>
								<div className="column field">
									<label htmlFor="">ผู้อนุมัติ/ผู้ตรวจสอบ</label>
									<input type="text"
									       name="approved_user_id"
									/>
								</div>
								<div className="column field">
									<label>พนักงานที่รับผิดชอบ</label>
									<input type="text"
									       name="responsibility_user_id[]"
									/>
								</div>
								<div className="column field">
									<label htmlFor="">Serial Number</label>
									<input type="text"
									       name="search_product_serial_number[]"
									/>
								</div>
								{
									(this.state.isOnlyStockTransfer
										|| this.state.isOnlyStockAdjustment
										|| this.state.isOnlyRequisition
									)
									&&
									<div className="column col-lg-three"
									     style={{
										     marginBottom: '1rem',
										     flexBasis: '100%',
										     maxWidth: '100%',
									     }}
									>
										<div className="flex row wrap menu-style-1">
											{/*<div className="item active" data-value="purchase_order">ซื้อ</div>*/}
											{/*<div className="item" data-value="sale_order">ขาย</div>*/}
											<div className="item"
											     data-value="stock_transfer"
											     ref={(ref) => {
												     setTimeout(() => {
													     if (this.state.isOnlyStockTransfer) {
														     window.$(ref).trigger('click');
													     }
												     }, 10);
											     }}
											>โอนย้ายสินค้าระหว่างคลัง
											</div>
											<div className="item"
											     data-value="stock_adjustment"
											     ref={(ref) => {
												     setTimeout(() => {
													     if (this.state.isOnlyStockAdjustment) {
														     window.$(ref).trigger('click');
													     }
												     }, 10);
											     }}
											>ปรับสินค้าคงคลัง
											</div>
											<div className="item"
											     data-value="requisition"
											     ref={(ref) => {
												     setTimeout(() => {
													     if (this.state.isOnlyRequisition) {
														     window.$(ref).trigger('click');
													     }
												     }, 10);
											     }}
											>เบิกใช้สินค้า
											</div>
											{/*<div className="item" data-value="bom_adjustment">ผลิตสินค้า</div>*/}
											{/*<div className="item" data-value="between_branch">ระหว่างสาขา</div>*/}
										</div>
									</div>
								}
								{
									this.state.isOnlyStockTransfer
									&&
									<div className="column field">
										<label htmlFor="">โอนออกจากคลังสินค้า</label>
										<input type="text"
										       name="stock_id"
										       autoComplete="off"
										/>
									</div>
								}
								{
									this.state.isOnlyStockAdjustment
									&&
									<div className="column field">
										<label htmlFor="">คลังสินค้า</label>
										<input type="text"
										       name="stock_id"
										       autoComplete="off"
										/>
									</div>
								}
								{
									this.state.isOnlyRequisition
									&&
									<div className="column field">
										<label htmlFor="">คลังสินค้า</label>
										<input type="text"
										       name="stock_id"
										       autoComplete="off"
										/>
									</div>
								}

								<div className="column field"
								     data-filter-source="purchase_order"
								     style={{display: 'none'}}>
									<label htmlFor="">ประเภท</label>
									<select className="ui dropdown fluid"
									        name="purchase_order_method[]"
									        data-form2_setup="true">
										<option value="all">ทุกประเภท</option>
										<option value="receive">รับสินค้า</option>
										<option value="return">คืนสินค้า</option>
									</select>
								</div>
								<div className="column field"
								     data-filter-source="purchase_order"
								     style={{display: 'none'}}>
									<label htmlFor="">สถานะ</label>
									<select className="ui dropdown fluid"
									        name="purchase_order_status[]"
									        multiple="multiple"
									        data-onchange=""
									        data-form2_setup="true">
										<option value="">ทุกสถานะ</option>
										<option value="draft">ฉบับร่าง</option>
										<option value="complete">สมบูรณ์</option>
										<option value="void">ยกเลิก</option>
									</select>
								</div>

								<div className="column field"
								     data-filter-source="sale_order"
								     style={{display: 'none'}}>
									<label htmlFor="">ประเภท</label>
									<select className="ui dropdown fluid"
									        name="sale_order_method[]"
									        data-form2_setup="true">
										<option value="all">ทุกประเภท</option>
										<option value="deliver">ส่งสินค้า</option>
										<option value="return">คืนสินค้า</option>
									</select>
								</div>
								<div className="column field"
								     data-filter-source="sale_order"
								     style={{display: 'none'}}>
									<label htmlFor="">สถานะ</label>
									<select className="ui dropdown fluid"
									        name="sale_order_status[]"
									        multiple="multiple"
									        data-onchange=""
									        data-form2_setup="true">
										<option value="">ทุกสถานะ</option>
										<option value="draft">ฉบับร่าง</option>
										<option value="complete">สมบูรณ์</option>
										<option value="void">ยกเลิก</option>
									</select>
								</div>

								<div className="column field"
								     data-filter-source="stock_transfer"
								     style={{display: 'none'}}>
									<label htmlFor="">โอนเข้าคลังสินค้า</label>
									<input type="text"
									       name="stock_transfer_stock_2_id"
									       autoComplete="off"
									/>
								</div>
								<div className="column field"
								     data-filter-source="stock_transfer"
								     style={{display: 'none'}}>
									<label htmlFor="">สถานะ</label>
									<select className="ui dropdown fluid"
									        name="stock_transfer_status[]"
									        multiple="multiple"
									        data-onchange=""
									        data-form2_setup="true">
										<option value="">ทุกสถานะ</option>
										<option value="draft">ฉบับร่าง</option>
										<option value="done">เสร็จสิ้น</option>
										<option value="void">ยกเลิก</option>
									</select>
								</div>

								<div className="column field"
								     data-filter-source="stock_adjustment"
								     style={{display: 'none'}}>
									<label htmlFor="">สถานะ</label>
									<select className="ui dropdown fluid"
									        name="stock_adjustment_status[]"
									        multiple="multiple"
									        data-onchange=""
									        data-form2_setup="true">
										<option value="">ทุกสถานะ</option>
										<option value="draft">ฉบับร่าง</option>
										<option value="done">สมบูรณ์</option>
										<option value="void">ยกเลิก</option>
									</select>
								</div>

								<div className="column field"
								     data-filter-source="requisition"
								     style={{display: 'none'}}>
									<label htmlFor="">ประเภท</label>
									<select className="ui dropdown fluid"
									        name="requisition_method"
									        data-form2_setup="true">
										<option value="">ทุกประเภท</option>
										<option value="borrow">เบิกสินค้า</option>
										<option value="return">คืนสินค้า</option>
									</select>
								</div>
								{
									(
										this.state.isOnlyRequisition
										&& this.state.qs.requisition_method === 'borrow'
									)
									&&
									<>
										<div className="column field"
										     data-filter-source="requisition"
										     style={{display: 'none'}}>
											<label htmlFor="">เบิกใช้กับ</label>
											<select className="ui dropdown" name="borrow_type" data-form2_setup="true">
												<option value="">เบิกใช้กับ</option>
												<option value="user">พนักงาน</option>
												<option value="team">ทีม</option>
												<option value="stock">เครื่องผลิตสินค้า</option>
												<option value="project">โครงการ</option>
												<option value="relationship">คู่ค้า</option>
												<option value="payment">เอกสารทางการเงิน</option>
												<option value="sale_order_contact">สัญญา</option>
												<option value="null">ไม่ระบุ</option>
												<option value="all">ทุกประเภท</option>
											</select>
										</div>
										<div className="column field"
										     data-filter-source="requisition"
										     style={{display: 'none'}}>
											<label htmlFor="">เกี่ยวข้องกับ</label>
											<div id="reference_id_1"/>
										</div>
									</>
								}
								<div className="column field"
								     data-filter-source="requisition"
								     style={{display: 'none'}}>
									<label htmlFor="">สถานะ</label>
									<select className="ui dropdown fluid"
									        name="requisition_status[]"
									        multiple="multiple"
									        data-onchange=""
									        data-form2_setup="true">
										<option value="">ทุกสถานะ</option>
										<option value="draft">ฉบับร่าง</option>
										<option value="done">สมบูรณ์</option>
										<option value="void">ยกเลิก</option>
									</select>
								</div>

								<div className="column field"
								     data-filter-source="bom_adjustment"
								     style={{display: 'none'}}>
									<label htmlFor="">คลังสินค้าวัตถุดิบ</label>
									<input type="text"
									       name="bom_adjustment_material_stock_id[]"
									       autoComplete="off"
									/>
								</div>
								<div className="column field"
								     data-filter-source="bom_adjustment"
								     style={{display: 'none'}}>
									<label htmlFor="">คลังสินค้าผลลัพธ์</label>
									<input type="text"
									       name="bom_adjustment_responsibility_user_id[]"
									       autoComplete="off"
									/>
								</div>
								<div className="column field"
								     data-filter-source="bom_adjustment"
								     style={{display: 'none'}}>
									<label htmlFor="">ผู้รับผิดชอบ/ควบคุม</label>
									<input type="text"
									       name="bom_adjustment_material_result_id[]"
									       autoComplete="off"
									/>
								</div>
								<div className="column field"
								     data-filter-source="bom_adjustment"
								     style={{display: 'none'}}>
									<label htmlFor="">วันที่เริ่มผลิต</label>
									<div data-form_calendar="date"
									     data-input_name="bom_adjustment_start_start_date"
									     data-placeholder="ช่วงวันที่เริ่มผลิต"
									     data-end_calendar="bom_adjustment_end_start_date"
									     data-locale="th"
									     data-initialdate=""
									/>
								</div>
								<div className="column field"
								     data-filter-source="bom_adjustment"
								     style={{display: 'none'}}>
									<label htmlFor="">ถึงวันที่เริ่มผลิต</label>
									<div data-form_calendar="date"
									     data-input_name="bom_adjustment_end_start_date"
									     data-placeholder="ถึงวันที่เริ่มผลิต"
									     data-start_calendar="bom_adjustment_start_start_date"
									     data-locale="th"
									     data-initialdate=""
									/>
								</div>
								<div className="column field"
								     data-filter-source="bom_adjustment"
								     style={{display: 'none'}}>
									<label htmlFor="">วันที่ผลิตเสร็จ</label>
									<div data-form_calendar="date"
									     data-input_name="bom_adjustment_start_done_date"
									     data-placeholder="ช่วงวันที่ผลิตเสร็จ"
									     data-end_calendar="bom_adjustment_end_done_date"
									     data-locale="th"
									     data-initialdate=""
									/>
								</div>
								<div className="column field"
								     data-filter-source="bom_adjustment"
								     style={{display: 'none'}}>
									<label htmlFor="">ถึงวันที่ผลิตเสร็จ</label>
									<div data-form_calendar="date"
									     data-input_name="bom_adjustment_end_done_date"
									     data-placeholder="ถึงวันที่ผลิตเสร็จ"
									     data-start_calendar="bom_adjustment_start_done_date"
									     data-locale="th"
									     data-initialdate=""
									/>
								</div>
								<div className="column field"
								     data-filter-source="bom_adjustment"
								     style={{display: 'none'}}>
									<label htmlFor="">สถานะ</label>
									<select className="ui dropdown fluid"
									        name="bom_adjustment_status[]"
									        multiple="multiple"
									        data-onchange=""
									        data-form2_setup="true">
										<option value="">ทุกสถานะ</option>
										<option value="draft">ฉบับร่าง</option>
										<option value="complete">สมบูรณ์</option>
										<option value="void">ยกเลิก</option>
									</select>
								</div>

								<div className="column field"
								     data-filter-source="between_branch"
								     style={{display: 'none'}}>
									<label htmlFor="">เกี่ยวข้องกับสาขา</label>
									<input type="text"
									       name="related_branch_id"
									       placeholder="เกี่ยวข้องกับสาขา"
									/>
								</div>
								<div className="column field"
								     data-filter-source="between_branch"
								     style={{display: 'none'}}>
									<label htmlFor="">ประเภท</label>
									<select className="ui dropdown fluid"
									        name="between_branch_method[]"
									        data-form2_setup="true">
										<option value="all">ทุกประเภท</option>
										<option value="deliver">ส่งสินค้าระหว่างสาขา</option>
										<option value="receive">รับสินค้าระหว่างสาขา</option>
										<option value="request">ขอสินค้าระหว่างสาขา</option>
										<option value="return">คืนสินค้า</option>
									</select>
								</div>
								<div className="column field"
								     data-filter-source="between_branch"
								     style={{display: 'none'}}>
									<label htmlFor="">สถานะ</label>
									<select className="ui dropdown fluid"
									        name="between_branch_status[]"
									        multiple="multiple"
									        data-onchange=""
									        data-form2_setup="true">
										<option value="">ทุกสถานะ</option>
										<option value="draft">ฉบับร่าง</option>
										<option value="wait_processing">รอดำเนินการ</option>
										<option value="processing">อยู่ระหว่างดำเนินการ</option>
										<option value="done">เสร็จสิ้น</option>
										<option value="void">ยกเลิก</option>
									</select>
								</div>

								<input type="hidden" name="is_advance_report"/>

								<div className="column fluid field right floated" style={{marginBottom: '1rem'}}>
									<label htmlFor="">&nbsp;</label>
									<div className="flex row wrap">
										<button className="ui icon green button"
										        style={{margin: '0 1rem 0 0'}}
										        type="button"
										        onClick={() => {
											        window.Global.reactToDom(
												        window.$('body'),
												        <ShipmentProductAudit
													        product={
														        this.state.has_product.length
															        ? this.state.has_product[0]
															        : false
													        }
												        />
											        );
										        }}
										>
											<i className="history icon" style={{height: 'initial'}}/> ตรวจสอบสินค้า
										</button>
										<div style={{
											position: 'relative',
											margin: '0 0.8rem 0 0',
										}}>
											<div className="ui labeled icon top right pointing dropdown button basic">
												<i className="download icon"/>
												<span className="text">รายงาน</span>
												<div className="menu">
													<div className="item" data-value="excel">รายงาน</div>
													<div className="item"
													     data-value="excel_is_display_shipment_item_by_product_filter">
														รายงาน : แสดงเฉพาะสินค้าที่กรอง
													</div>
												</div>
											</div>
										</div>
										<div>
											<button className="ui icon button right floated"
											        type="submit">
												<i className="search icon" style={{height: 'initial'}}/> ค้นหา
											</button>
										</div>
									</div>
								</div>
							</div>
						</form>
					</div>
				</div>
				{
					this.state.isLoading
					&& <div className="Stock_topLoadingRoot">
						<div className="flex row center-xs middle-xs">
							<div className="ui active centered inline small loader"/>
						</div>
					</div>
				}
				{
					!this.state.isLoading
					&&
					<div id="shipment-list">
						{
							(() => {
								// if (this.state.qs.is_advance_report !== "1") {
								// 	return null;
								// }
								return (
									<div className="ui box"
									     ref={(ref) => {
										     Helper.nodeMaxHeight(ref, {
											     maxHeight: 300
										     });
									     }}
									     style={{
										     position: 'relative',
										     background: 'linear-gradient(253deg, #201f1f, #0a151d, #0f0f0f)',
										     color: '#FFF',
										     padding: '2rem',
										     overflowX: 'auto'
									     }}>
										{
											<div className="flex row wrap middle-xs between-xs">
												<h2 style={{margin: '0 1rem 0 0', color: 'gold'}}>
													<i className="clone outline icon"
													   style={{fontSize: '1.3rem', margin: '0 0.8rem 0 0'}}/>
													<span>
														<span>สรุปยอดความเคลื่อนไหวสินค้า</span>
														<br/>
														<span
															style={{fontSize: '1rem', fontWeight: 100, opacity: 0.7, color: '#FFF'}}>แสดงยอดสรุปปริมาณสินค้าที่อยู่ระหว่างวันที่ดำเนินการ และยอดก่อนและหลังของช่วงเวลาดังกล่าว</span>
													</span>
												</h2>
												<div className="flex row wrap">
													{
														buttons.map((d, i) => {
															if (d.hide) return null;

															return <button type="button"
															               key={i}
															               style={d.style}
															               className="ui button circular small green"
															               onClick={() => {
																               window.$('#start_done_date-calendar').calendar(
																	               'set date',
																	               window.moment(d.start_done_date, 'YYYY-MM-DD').toDate()
																               )
																               window.$('#end_done_date-calendar').calendar(
																	               'set date',
																	               window.moment(d.end_done_date, 'YYYY-MM-DD').toDate()
																               )
																               setTimeout(() => {
																	               window.$('#Search_root form').trigger('submit');
																               }, 100);
															               }}
															>
																{d.title}
															</button>;
														})
													}
												</div>
											</div>
										}

										{
											this.state.company_info
											&& this.state.company_info.chart_product_cost_calculate_is_processing === 1
											&& <div style={{margin: '1rem 0 0 0'}}>ขออภัย กำลังประมวลผลสถิติ
												ขั้นตอนนี้อาจใช้เวลาสูงสุดถึง 3 ชั่วโมง
												คุณสามารถกลับมาดูสถิติได้ใหม่ภายหลัง</div>
										}

										{
											isAlready
											&& summary
											&&
											<table style={{margin: '1rem 0 0 0'}}
											       className="new-table">
												<thead>
												<tr>
													<th/>
													{
														!this.state.isHideStockStats
														&&
														<th>
															<div ref={(ref) => {
																window.$(ref)
																	.popup({
																		// inline     : true,
																		html: 'ยอด ณ วันที่ ' + window.moment(this.state.qs.start_done_date).subtract(1, 'days').format('D MMMM YYYY'),
																		hoverable: true,
																		position: 'top center'
																	});
															}}>
																{window.moment(this.state.qs.start_done_date).subtract(1, 'days').format('D/M')}
																<span
																	style={{fontSize: '0.8rem', position: "absolute", top: -3}}> *</span>
															</div>
														</th>
													}
													{
														keys.map((key, i) => {
															let text = '';
															switch (key) {
																case 'purchase_order_amount':
																	text = 'ซื้อ';
																	break;
																case 'sale_order_amount':
																	text = 'ขาย';
																	break;
																case 'requisition_amount':
																	text = 'เบิก';
																	break;
																case 'bom_adjustment_amount':
																	text = 'ผลิต';
																	break;
																case 'stock_transfer_in':
																	text = 'โอน';
																	break;
																case 'stock_adjustment_amount':
																	text = 'ปรับ';
																	break;
																case 'between_branch_deliver':
																	text = 'ส่งสาขา';
																	break;
																case 'between_branch_receive':
																	text = 'สาขารับ';
																	break;
																case 'between_branch_return':
																	text = 'สาขาคืน';
																	break;
																case 'product_initial_amount':
																	text = 'ยกมา';
																	break;
																default:
																	break;
															}
															return <th key={i}
															           style={{
																           // transform: 'rotate(313deg)'
															           }}>{text}</th>
														})
													}
													{
														!this.state.isHideStockStats
														&&
														<th>
															<div ref={(ref) => {
																window.$(ref)
																	.popup({
																		// inline     : true,
																		html: 'ยอด ณ วันที่ ' + window.moment(this.state.qs.end_done_date).format('D MMMM YYYY'),
																		hoverable: true,
																		position: 'top center'
																	});
															}}>
																{/*คงเหลือ*/}
																{window.moment(this.state.qs.end_done_date).format('D/M')}
																<span
																	style={{fontSize: '0.8rem', position: "absolute", top: -3}}> *</span>
															</div>
														</th>
													}
													{/*<th>นับ</th>*/}
													{/*<th>ผลต่าง</th>*/}
												</tr>
												</thead>
												<tbody>
												{
													Object.keys(summary.product_id).map((k, i) => {
														if (this.state.has_product.length) {
															let isFilter = false;
															for (let x in this.state.has_product) {
																if (this.state.has_product[x]['id'] + '' === k + '') {
																	isFilter = true;
																}
															}
															if (!isFilter) {
																return null;
															}
														}

														return (
															<tr key={i} style={{fontSize: '1.2rem'}}>
																<td>
																	<div className="flex row middle-xs wrap">
																		<div className="ui avatar image"
																		     style={{
																			     marginRight: '0.5rem',
																			     flexShrink: 0,
																			     width: '1.3rem',
																			     height: '1.3rem',
																		     }}>
																			<img
																				src={summary.product_id[k]['product'].product_image_file_upload.url}
																				style={{
																					width: '1.3rem',
																					height: '1.3rem',
																				}}
																				alt=""/>
																		</div>
																		<div style={{cursor: 'pointer'}}
																		     onClick={() => {
																			     let data = window.$('#Search_root form').serializeObject();
																			     data.has_product_ids = summary.product_id[k]['product'].id;
																			     this.props.history.push(window.Global.getQueryStringLinkFromObject(data));
																		     }}>{summary.product_id[k]['product']['name']}</div>
																	</div>
																</td>
																{
																	!this.state.isHideStockStats
																	&&
																	<td style={{color: 'deepskyblue'}}>
																		<b>{summary.product_id[k]['prev']['on_hand'].format(6)}<span
																			className="unit-name"> {window.GlobalFunc.getUnitNameByQuantity2({
																			product: summary.product_id[k]['product'],
																			quantity: summary.product_id[k]['prev']['on_hand'],
																			ratio: summary.product_id[k]['product'].sell_price[0].ratio
																		})['unit_name']}</span></b>
																	</td>
																}
																{
																	keys.map((key, x) => {
																		if (!summary.product_id[k][key]) {
																			return <td key={x}/>
																		}

																		if (key === 'between_branch_deliver') {
																			summary.product_id[k][key] = -summary.product_id[k][key];
																		}

																		let style = {
																			textAlign: 'center',
																			fontWeight: 'bold'
																		};
																		if (summary.product_id[k][key] > 0) {
																			style.color = 'limegreen';
																		} else {
																			style.color = 'red';
																		}

																		if (key === 'stock_transfer_in' || key === 'stock_transfer_out') {
																			style.color = 'rgba(255,255,255,0.82)';
																		}

																		return (
																			<td key={x}
																			    style={style}>
																				{summary.product_id[k][key].format(6)}<span
																				className="unit-name"> {window.GlobalFunc.getUnitNameByQuantity2({
																				product: summary.product_id[k]['product'],
																				quantity: summary.product_id[k][key],
																				ratio: summary.product_id[k]['product'].sell_price[0].ratio
																			})['unit_name']}</span>
																			</td>
																		)
																	})
																}
																{
																	!this.state.isHideStockStats
																	&&
																	<td style={{color: 'gold'}}>
																		<b>{summary.product_id[k]['current']['on_hand'].format(6)}<span
																			className="unit-name"> {window.GlobalFunc.getUnitNameByQuantity2({
																			product: summary.product_id[k]['product'],
																			quantity: summary.product_id[k]['current']['on_hand'],
																			ratio: summary.product_id[k]['product'].sell_price[0].ratio
																		})['unit_name']}</span></b>
																	</td>
																}
															</tr>
														)
													})
												}
												</tbody>
											</table>
										}
										{
											this.state.company_info
											&&
											<div className="flex flex-row items-center justify-between"
											     style={{color: '#CCC', fontSize: '0.8rem', margin: '1rem 0 0 0'}}>
												{
													this.state.company_info.chart_product_cost_calculate_last_date
														?
														<div>*
															ข้อมูลอัพเดทล่าสุดวันที่ <b className={'text-white'}>{window.Global.getDateThai(this.state.company_info.chart_product_cost_calculate_last_date)}</b>
														</div>
														:
														<div>
															สรุปยอดความเคลื่อนไหวสินค้า กำลังประมวลผลข้อมูลอยู่... โปรดลองใหม่ภายหลัง
														</div>
												}
												<div>*สรุปยอดความเคลื่อนไหวสินค้า จะไม่แสดงเมื่อช่วงระยะวันที่ดำเนินการเกิน <span className={'font-bold text-white'}>2 เดือน</span></div>
											</div>
										}
									</div>
								)
							})()
						}
						<div className="ui basic table can click Table_root td-top-xs">
							<div className="thead">
								<div className="tr">
									<div className="th span1 half">เหตุการณ์</div>
									<div className="th span1 half">เลขที่เอกสาร</div>
									<div className="th span1 half">วันที่เอกสาร</div>
									<div className="th span1 half">วันที่ดำเนินการ/วิธีจัดส่ง</div>
									<div className="th span1 half">คลังสินค้า</div>
									<div className="th span3">สินค้า</div>
									<div className="th span2">คู่ค้า/รายละเอียด</div>
									<div className="th span2">ผู้บันทึก/ผู้แก้ไข</div>
									<div className="th span1 half"/>
								</div>
							</div>
							<div className="tbody">
								{
									this.state.shipments.map((shipment, i) => {
										if (shipment.source === 'bom_adjustment') {
											shipment.shipment_item = [];
											shipment.shipment_bom_adjustment_round.map((shipment_bom_adjustment_round, i) => {
												shipment_bom_adjustment_round.shipment_item.map((shipment_item, i) => {
													shipment.shipment_item.push(shipment_item);
													return true;
												});
												return true;
											});
										}
										return (
											<Link to={shipment.url || '#'}
											      key={i}
											      className='tr'
											      ref={(ref) => {
												      if (!ref) return

												      window.$(ref).on('click', function (e) {
													      if (window.$(e.target).closest('.data-disable-click').length) {
														      e.preventDefault();
														      return
													      }

													      if ((e.ctrlKey || e.metaKey)) {
														      let dataHref = window.$(e.target).attr('data-href');
														      if (dataHref) {
															      e.preventDefault();
															      window.open(dataHref);
														      }
														      return true;
													      }

													      let dataHref = window.$(e.target).attr('data-href');
													      if (dataHref) {
														      e.preventDefault();
														      window.location = dataHref;
														      return;
													      }

													      let href = window.$(ref).attr('href');
													      if (href.indexOf('/v2') === -1) {
														      e.preventDefault();
														      window.location = href;
													      }
												      });

												      // window.GlobalFunc.setupShortPopupDisplayProduct(window.$(ref), {
												      //    item: shipment.shipment_item
												      // });

												      this.processShowManageButton(window.$(ref), shipment);

												      setTimeout(() => {
													      let $Search_root = window.$('#Search_root');
													      let product_ids = $Search_root.find('.Explorer[data-explorer_input_name="has_product_ids[]"]').explorer('get value');
													      let search_product_serial_number = $Search_root.find('.Explorer[data-explorer_input_name="search_product_serial_number[]"]').explorer('get value');

													      let isHasYellow = false;

													      if (product_ids.length
														      || search_product_serial_number.length
													      ) {
														      window.$(ref).find('.shipment-item').each((i, e) => {
															      let $this = window.$(e);
															      let isOk = false;

															      $this.find('.product-serial-number').each(function () {
																      if (search_product_serial_number.indexOf(window.$(this).data('product_serial_number_id') + '') !== -1) {
																	      isOk = true;
																	      window.$(this).addClass('black');
																      }
															      });

															      if (product_ids.indexOf($this.data('product_id') + '') !== -1) {
																      isOk = true;
															      }

															      if (isOk) {
																      let $r = $this.parent().parent();
																      $this.find('>div:first-child').css({background: 'yellow'});

																      let $clone = $r.clone(true);
																      $r.parent().prepend($clone);
																      $r.remove();
															      } else {
																      isHasYellow = true;
																      $this.parent().parent().hide();
															      }
														      })
													      }

													      if (isHasYellow) {
														      let $bu = window.$('<div class="ui button tiny data-disable-click">อื่นๆ</div>');
														      window.$(ref).find('.wrapper-shipment-item').append($bu);
														      $bu.on('click', (e) => {
															      e.preventDefault();
															      window.$(ref).find('.shipment-item').each((i, e) => {
																      window.$(e).parent().parent().show();
															      });
															      $bu.remove();
														      })
													      }
												      }, 100);
											      }}
											      data-no_navigo="">
												<div className="td span1 half">
													<div>
														{/*<div id='more-info-button' className='hover-transparent'>*/}
														{/*	<i className='info circle icon'/>*/}
														{/*</div>*/}
														<div>
															<b style={{fontSize: '1.2rem'}}>{shipment.description}</b>
														</div>
														<div style={{marginTop: '0.5rem'}}>
															{
																shipment.tag
																&&
																shipment.tag.map((tag, i) => {
																	return (
																		<div key={i}
																		     className={"ui label tiny"}>
																			{tag}
																		</div>
																	)
																})
															}
														</div>
													</div>
												</div>
												<div className="td span1 half">
													<div>
														<div>{shipment.desc}</div>
													</div>
												</div>
												<div className="td span1 half">
													<div>
														<div><b>{shipment.doc_date.date()}</b></div>
														<div dangerouslySetInnerHTML={{__html: shipment.status_html}}
														     style={{marginTop: '1rem'}}
														/>
														<div
															dangerouslySetInnerHTML={{__html: shipment.shipment_item_quantity_action_status_html}}/>
													</div>
												</div>
												<div className="td span1 half">
													<div>
														{
															shipment.done_date
															&&
															<div><b>{shipment.done_date.date()}</b></div>
														}
														{
															shipment.responsibility_user
															&&
															<div style={{marginTop: '0.5rem'}}>
																<div key={i}
																     data-tooltip='พนักงานที่รับผิดชอบ'
																     data-inverted=""
																     className={"ui label tiny"}>
																	{shipment.responsibility_user.name}
																</div>
															</div>
														}
														<div style={{marginTop: '0.5rem'}}>
															{
																shipment.delivery_type2
																	? <div data-tooltip='วิธีการส่งสินค้า'
																	       data-inverted="">
																		{shipment.delivery_type2}
																	</div>
																	: null
															}
															{
																shipment.shipment_method
																	? <div data-tooltip='วิธีการส่งสินค้า'
																	       data-inverted="">
																		{shipment.shipment_method.name}
																	</div>
																	: null
															}
															{
																shipment.shipment_tracking_remark
																	? <div data-tooltip='รหัสติดตามพัสดุ/ทะเบียนรถ'
																	       data-inverted="">
																		{shipment.shipment_tracking_remark}
																	</div>
																	: null
															}
															{
																shipment.postcode
																	? <div data-tooltip='รหัสไปรษณีย์'
																	       data-inverted="">
																		{shipment.postcode}
																	</div>
																	: null
															}
															{
																shipment.phone
																	? <div data-tooltip='โทรศัพท์'
																	       data-inverted="">
																		{shipment.phone}
																	</div>
																	: null
															}
														</div>
													</div>
												</div>
												<div className="td span1 half">
													<div>
														<div>
															{shipment.stock.name}
														</div>
														{
															shipment.stock_2 &&
															<>
																<div className="flex row middle-xs"
																     style={{padding: '0 0 0.4rem 0', opacity: 0.5}}>
																	<i className="icon arrow circle down"/>
																</div>
																<div>
																	{shipment.stock_2.name}
																</div>
															</>
														}
													</div>
												</div>
												<div className="td span3 wrapper-shipment-item">
													<div style={{position: 'relative'}}
														// ref={(ref) => {
														//    Helper.nodeMaxHeight(ref, {
														//      maxHeight: 100
														//    });
														// }}
													>
														{
															shipment.shipment_item
															&& shipment.shipment_item.map((shipment_item, i) => {
																return (
																	<div key={i}
																	     className="flex row"
																	     style={{
																		     marginBottom: shipment.shipment_item.length === i + 1
																			     ? 0
																			     : '0.8rem'
																	     }}
																	>
																		<div style={{width: '100%', flexShrink: 1}}>
																			<ShipmentItem
																				shipment={shipment}
																				shipment_item={shipment_item}
																				isTinySerialNumber={true}
																				isDisabledDescription={true}
																				isDisplayQuantity={true}
																				isDisplayBom={true}
																			/>
																		</div>
																	</div>
																)
															})
														}
													</div>
												</div>
												<div className="td span2">
													<div>
														<div><b>
															{
																shipment.relationship
																&&
																shipment.relationship.name
															}
															{
																shipment.relationship_branch
																&&
																<>
																	<br/>{shipment.relationship_branch.name}
																</>
															}
															{
																shipment.borrow_user
																&&
																shipment.borrow_user.name
															}
														</b></div>
													</div>
												</div>
												<div className="td span2">
													<div>
													<span data-tooltip='ผู้บันทึกข้อมูล' data-inverted="">
														<b>บันทึกโดย</b> {shipment.created_user.name} @ <span>{shipment.date_created.date()}</span>
													</span>
														{
															shipment.updated_user &&
															<>
																<br/>
																<span data-tooltip='ผู้แก้ไขข้อมูล' data-inverted="">
																<b>แก้ไขโดย</b> {shipment.updated_user.name} @ <span>{shipment.date_updated.date()}</span>
															</span>
															</>
														}
														{
															shipment.approve_user &&
															<>
																<br/>
																<span data-tooltip='ผู้อนุมัติ/ผู้ตรวจสอบ' data-inverted="">
																<b>อนุมัติโดย</b> {shipment.approve_user.name} @ <span>{shipment.date_approved.date()}</span>
															</span>
															</>
														}
													</div>
												</div>
												<div className="td span1 half">
													<div className='flex row wrap between-xs'>
														<div>
														<span id='create-deliver-button'
														      className='ui button green'
														      data-href={'/shipments/new?source=' + shipment.source + '&method=deliver&related_shipment_id=' + shipment.id}
														      style={{display: 'none'}}>
														 ทำใบส่งสินค้า
														</span>
															<span id='receive-button'
															      className='ui button green'
															      data-href={'/shipments/new?source=' + shipment.source + '&method=receive&related_shipment_id=' + shipment.id}
															      style={{display: 'none'}}>
															รับสินค้า
														</span>
															<span id='return-button'
															      className='ui button green'
															      data-href={'/shipments/new?source=' + shipment.source + '&method=return&related_shipment_id=' + shipment.id}
															      style={{display: 'none'}}>
															คืนสินค้า
														</span>
														</div>
													</div>
												</div>
											</Link>
										)
									})
								}

								{
									!this.state.isLoading
									&& this.state.shipments.length === 0
									&& (
										!window.Global.getAllQueryStrings().page
										|| window.Global.getAllQueryStrings().page === '1'
									) &&
									<div className="tr">
										<div className="td span16" style={{textAlign: 'center'}}>ไม่พบข้อมูล</div>
									</div>
								}
							</div>
						</div>
					</div>
				}
			</div>
		);
	}

	render() {
		return this.renderList();
	}
}


export class ShipmentItem extends React.Component {
	serialNumber(shipment_item_serial_number) {
		return (
			shipment_item_serial_number.map((shipment_item_serial_number, i) => {
				let t = '';
				let product_serial_number_id = '';
				if (typeof shipment_item_serial_number.serial_number !== "undefined") {
					// กรณี requisition > borrow โครงสร้างตอบกลับไม่เหมือนประเภทอื่น
					t = shipment_item_serial_number.serial_number;

					product_serial_number_id = shipment_item_serial_number.id;
				} else {
					t = shipment_item_serial_number.product_serial_number.serial_number;

					product_serial_number_id = shipment_item_serial_number.product_serial_number.id;
				}

				if (!t) {
					t = '-';
				}

				return (
					<div key={i}
					     data-product_serial_number_id={product_serial_number_id}
					     className={this.props.isTinySerialNumber ? "ui label tiny product-serial-number" : "ui label product-serial-number"}>
						{t}
					</div>
				)
			})
		)
	}

	render() {
		return (
			<div className="shipment-item"
			     data-product_id={this.props.shipment_item.product.id}
			>
				<div className="flex row between-xs">
					<div className="flex row">
						<div className="ui avatar image" style={{marginRight: '0.8rem', flexShrink: 0}}>
							<img src={this.props.shipment_item.product.product_image_file_upload.url}
							     alt={"stockAdjustment"}/>
						</div>
						<div>
							<div style={{marginTop: "0.25rem"}}
							     className="product-name">
								{this.props.shipment_item.product.name}
								{/*	<span*/}
								{/*		data-href={"/v2/products/" + this.props.shipment_item.product.id}*/}
								{/*		data-target="_blank">*/}
								{/*	<i*/}
								{/*		className="icon linkify"*/}
								{/*		style={{*/}
								{/*			fontSize: '0.8rem',*/}
								{/*			margin: 0,*/}
								{/*			color: '#646464'*/}
								{/*		}}/>*/}
								{/*</span>*/}
							</div>
							<div style={{marginTop: "0.3rem"}}>
								{
									this.props.shipment_item.shipment_item_serial_number
										?
										this.serialNumber(this.props.shipment_item.shipment_item_serial_number)
										: null
								}
								{
									this.props.shipment_item.product_serial_number
										?
										this.serialNumber(this.props.shipment_item.product_serial_number)
										: null
								}
								{
									this.props.shipment_item.shipment_item_stock_adjustment_serial_numbers
										?
										// ปรับสินค้าคงคลัง > กรณีลด
										this.serialNumber(this.props.shipment_item.shipment_item_stock_adjustment_serial_numbers)
										: null
								}
							</div>
							{
								typeof this.props.isDisabledDescription === 'undefined'
								&& this.props.shipment_item.description ?
									<div
										style={{whiteSpace: 'pre-line'}}>{this.props.shipment_item.description}</div>
									: null
							}
						</div>
					</div>
					{
						this.props.isDisplayQuantity
						&&
						<div className="right floated"
						     style={{
							     marginTop: '0.2rem',
							     flexShrink: 0,
							     textAlign: 'right'
						     }}>
							{
								window.GlobalFunc.getUnitNameByQuantity2({
									product: this.props.shipment_item.product,
									quantity: this.props.shipment_item.quantity_ship,
									ratio: this.props.shipment_item.ratio
								})['text']
							}
							{
								this.props.shipment
								&& this.props.shipment.source === 'stock_adjustment'
									?
									<>
										<br/>
										<span data-tooltip='จำนวนเปลี่ยนแปลง'
										      data-position="bottom left"
										      data-inverted="">({window.GlobalFunc.getUnitNameByQuantity2({
											product: this.props.shipment_item.product,
											quantity: this.props.shipment_item.quantity_action,
											ratio: this.props.shipment_item.ratio
										})['text']})</span>
									</>
									: null
							}
						</div>
					}
				</div>
				{
					this.props.isDisplayBom
					&& this.props.shipment_item.product.is_bom
						?
						<div style={{padding: '0 0 0 2.5rem'}}>
							{
								this.props.shipment_item.product.product_bom.map((product_bom, i) => {
									return (
										<ShipmentItem
											key={i}
											shipment={this.props.shipment || false}
											shipment_item={{
												product: product_bom.product,
												quantity_ship: this.props.shipment_item.quantity_ship * product_bom.quantity,
												ratio: product_bom.product.sell_price[0].ratio,
											}}
											isTinySerialNumber={true}
											isDisabledDescription={true}
											isDisplayQuantity={true}
										/>
									)
								})
							}
						</div>
						: null
				}
			</div>
		)
	}
}
